import type { WebLocale } from '@/enums/web-locale';
import type { ImpressionPixelConfigFile } from '@/features/impression-pixels/types';

import ImpressionPixelConfig from '@/features/impression-pixels/config.json';

import { formatExternalTracker } from '@/helpers/impression-tracker-helper';

const ALL_COUNTRIES_PIXEL = 'ALL';

/** Pulls the correct impression pixel URLs for the given provider short names and weblocale. */
export function getImpressionPixels(shortNames: string[], webLocale: WebLocale) {
	return [...new Set(shortNames)]
		.flatMap(shortName => (ImpressionPixelConfig as ImpressionPixelConfigFile)[shortName])
		.filter(
			data =>
				data != null &&
				data.enabled &&
				(data.webLocales.includes(webLocale) || data.webLocales === ALL_COUNTRIES_PIXEL)
		)
		.map(({ pixel }) => formatExternalTracker({ tracker: pixel, webLocale }));
}
